import CoreInput, { InputTypes as _InputTypes } from './CoreInput';

export type InputTypes = _InputTypes;
export default CoreInput;
